/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamConfig } from './oralExamConfig';

export type GenericApiResponseOralExamConfigData = OralExamConfig | null;
